export const SHARED_I18N_NAMESPACE = "shared";

export { default as enUS } from "./en-US";
export { default as frFR } from "./fr-FR";
